/* Store-credit coverage math. Pure, no DOM. All amounts in integer cents.
   Mirrors the eBike Accessory Credit discount function:
   credit = floor(bikePrice * percent%); applied greedily to lines in order. */
(function (root) {
  'use strict';

  function creditFromBikePrice(bikePriceCents, percent) {
    var pct = Number(percent);
    if (!isFinite(pct) || pct <= 0) pct = 10;
    return Math.floor((Math.max(0, Math.floor(bikePriceCents)) * pct) / 100);
  }

  // lines: ordered [{ key, priceCents, selected }] — accessories first, shipping last.
  function computeCoverage(creditCents, lines) {
    var remaining = Math.max(0, Math.floor(creditCents));
    var credit = remaining;
    var out = lines.map(function (l) {
      var price = Math.max(0, Math.floor(l.priceCents));
      if (!l.selected) {
        return { key: l.key, priceCents: price, selected: false, coveredCents: 0, oweCents: price };
      }
      var covered = Math.min(remaining, price);
      remaining -= covered;
      return { key: l.key, priceCents: price, selected: true, coveredCents: covered, oweCents: price - covered };
    });
    var selectedTotal = 0, pay = 0;
    out.forEach(function (l) { if (l.selected) { selectedTotal += l.priceCents; pay += l.oweCents; } });
    return {
      lines: out,
      remainingCents: remaining,
      appliedCents: credit - remaining,
      selectedTotalCents: selectedTotal,
      payCents: pay,
    };
  }

  var api = { creditFromBikePrice: creditFromBikePrice, computeCoverage: computeCoverage };
  root.StoreCreditCore = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);
